import Vue from 'vue'
import Vuex from 'vuex'
import VueGates from 'vue-gates';
import ModuleCustomsPatches from './modules/customs_patches.module';
import ModuleCustomsPatchesReport from './modules/reports/customs_patches_reports.module';
Vue.use(Vuex)
Vue.use(VueGates, {
  persistent: true
});

export default new Vuex.Store({
  state: {
    module: 'headers.n_pendings',
    minimenu: false,
    menu: true,
    layout: 'loading',
    loggedIn: false,
    loggedUsername: '',
    loggedPicture: null,
    loggedUserRole: '',
    loggedUserEmail: '',
    loggedUserPermissions: '',
    user_is_client_type: false,
    clients: [], // Array of asociate clients to user
    warehouseName: localStorage.getItem('warehouseName') || 'chronos',
    warehouseId: localStorage.getItem('warehouse_id') || 1,
    bottom: localStorage.getItem('bottom') || 0,
    clientId: '',
    clientShippingServices: [],
    clientName: '',  
    ptl_trace_id: '', // id to cancel or confirm selected orders in fulfillment ptl view
    ptl_trace_id_loaded: false,
    ffPtlPendings: [],
    language: localStorage.getItem('language') || 'es',
    theme: localStorage.getItem('theme') || 'light',
    chronosApi: process.env.NODE_ENV === 'production' ? 'https://api.eonwms.com/' : 'https://apisandbox.eonwms.com/',
    // chronosApi: 'http://localhost:3000/',
    rfidApi: process.env.NODE_ENV === 'production' ? 'https://rfid.eonwms.com/' : 'https://rfiddev.eonwms.com/',
    // rfidApi: 'http://192.168.2.126:3333/', // servidor daedalus
    eonShopsApi: 'https://ehub.yego.mx/',
    // eonShopsApi: 'http://localhost:3000/',
    printerServiceApi: 'http://localhost:5005/', // servicio local para imprimir y obtener las imprenpm soras
    loaderProps: {
      visible: false,
      color: 'blue_accent',
      overlarColor: 'grey',
      class: 'white_highlight--text',
      text: localStorage.getItem('language') == 'en' ? "LOADING..." : "CARGANDO...",
      lineColor: 'white',
    },
    channels: [
      { text: "ALIEXPRESS", value: "EON:AliExpress" },
      { text: "AMAZON", value: "EON:amazon" },
      { text: "CLARO SHOP", value: "EON:ClaroShop" },
      { text: "COPPEL", value: "EON:coppel" },
      { text: "ELEKTRA", value: "EON:Elektra" },
      { text: "FACEBOOK", value: "EON:Facebook" },
      { text: "MERCADO LIBRE", value: "EON:meli" },
      { text: "MOSTRADOR", value: "EON:Mostrador" },
      { text: "LIVERPOOL", value: "EON:LiverpoolEL" },
      { text: "SEARS", value: "EON:Sears" },
      { text: "SHOPIFY", value: "EON:Shopify" },
      { text: "TEMU", value: "EON:Temu" },
      { text: "TIKTOK", value: "EON:Tiktok" },
      { text: "WOOCOMERCE", value: "EON:WooCommerce" },
      { text: "WALMART", value: "EON:WalmartEL" }
    ],
    shipping_services: [
      { value: "AFIMEX", text: "AFIMEX" },
      { value: "FEDEX", text: "FEDEX" }, 
      { value: "IHS", text: "IHS" },
      { value: "MERQ", text: "MERQ" },
      { value: "OTRA", text: "OTRA" },
      { value: "QUALITYPOST", text: "QUALITY POST"},
      { value: "TIUI", text: "TIUI" },
      { value: "UPS", text: "UPS" },
      { value: "USPS", text: "USPS" },
      { value: "VENCEDOR", text: "VENCEDOR" },
    ],
    external_shipping_services: [
      "99MINUTOS", 
      "ALIEXPRESS", 
      "AM PM", 
      "AMAZON", 
      "CAINIAO",
      "COPPEL", 
      "DHL", 
      "ESTAFETA", 
      "FEDEX", 
      "HERMES", 
      "IMILE",
      "JTEXPRESS",
      "MERCADO COLECTA", 
      "MERQ", 
      "PAQUETEXPRESS", 
      "PICKUP", 
      "QUIKEN", 
      "UPS", 
      "WALMART", 
      "YEGO"
    ],
    years_catalog: Array.from({ length: new Date().getFullYear() - 2017 + 1 }, (_, i) => new Date().getFullYear() - i),
  },
  getters: {
    language: state => state.language
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    customs_patches: ModuleCustomsPatches,
    customs_patches_reports: ModuleCustomsPatchesReport
  }
})